export default __webpack_public_path__ + "static/media/gall2.ba6f14fa.png";